<div id="st-video">
    <div class="container">
        <div class="standard-heading row">
            <h2 class="h-medium col">회사소개</h2>
            <a class="w-btn col-auto" routerLink="/media-center/last-broadcast">
                <span class="h-small">모두보기</span>
                <div class="icon">
                    <svg width="18" height="10" viewBox="0 0 18 10" fill="none">
                        <path d="M12.5379 0L11.669 0.853659L15.5172 4.39024H0.62069C0.248276 4.39024 0 4.63414 0 5C0 5.36585 0.248276 5.60975 0.62069 5.60975H15.5172L11.669 9.14634L12.5379 10L18 5L12.5379 0Z" fill="black"/>
                    </svg>
                </div>
            </a>
        </div>
        
        <div class="featured-slider" data-display="4,3,2,2" data-nav="on">
            <div class="slider-content slider-ref">
                <div class="slider-wrapper row">
                
                    <div class="col-lg-4 item slide" *ngFor="let item of collection ; let i = index">
                        <div class="w-youtube-video">
                            <div class="img-wrapper">
                                <img src="{{item.pathImg}}">
                            </div>
                            <div class="static" *ngIf="item.link != '' && item.link != null"
                                [innerHtml]="item.link | playYoutubeFrame : i">
                            </div>
                        </div>

                        <div class="post-meta">
                            <h4 class="post-title">{{item.title}}</h4>
                            <div class="post-info">
                                <span class="time post-time">{{item.insDate}}</span>
                            </div>
                        </div>

                    </div>
    
                </div>		
            </div>
            		
        </div>

    </div>

    <div class="elements">
        <div class="element dots-horizontal" ratio="2">
            <img src="/assets/img/elements/dots-horizontal.svg">
        </div>   
        <div class="element triangle-green" ratio="2">
            <img class="element triangle-green" src="/assets/img/elements/triangle-green.svg">
        </div>
    </div>
</div>